import { memo, useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { useLanguage } from 'assets/languages';
import TextInputField from 'components/textInput';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { CampaignFormStepTwoContext } from 'pages/campaigns/campaignForm/components/campaignFormContainer/components/campaignFormSteps/components/campaignFormStepTwo/campaignFormStepTwo.context';
import CampaignFormField from 'pages/campaigns/campaignForm/components/campaignFormContainer/components/campaignFormSteps/components/campaignFormFieldGroup/components/campaignFormField/campaignFormField';
import TextArea from 'components/textArea';

const ReelsReferenceFields = () => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.pages.campaigns,
  };

  const {
    guidelineRuleFormMethods: { register, control },
  } = useContext(CampaignFormContext);
  const { validateMultipleUrlsInText, validateDocumentOrSnsPlatformsInText } = useContext(CampaignFormStepTwoContext);

  const reelsReferenceValue = useWatch({
    control,
    name: 'REELS_REFERENCE.value',
  });

  return (
    <div className="flex flex-col gap-[25px] mt-[50px]">
      <CampaignFormField label={languageTexts.create_reels_form_reference} labelClassName="!text-[17px]">
        <TextInputField
          register={register('REELS_REFERENCE.value', {
            onChange: (event) => validateMultipleUrlsInText(event?.target?.value || ''),
          })}
          bordered
          placeholder="https://www.instagram.com/reel/Cx1234abCdE"
        />
      </CampaignFormField>

      {/* 위 릴스에서 특별히 참고했으면 하는 점이 있나요? */}
      {reelsReferenceValue && (
        <CampaignFormField
          innerWrapperClassName="!gap-0"
          label={languageTexts.create_reels_form_reference_description_title}
          labelClassName="!text-[15px] !font-normal"
          description={languageTexts.create_reels_form_reference_description_desc}
          descriptionClassName="!text-[13px]"
        >
          <TextArea
            bordered
            placeholder={`${languageTexts.input}`}
            register={register('REELS_REFERENCE_DESCRIPTION.value', {
              onBlur: (event) => validateDocumentOrSnsPlatformsInText(event?.target?.value || ''),
            })}
            autoResize={true}
            inputStyle={{ display: 'block', minHeight: '83.52px' }}
          />
        </CampaignFormField>
      )}
    </div>
  );
};

export default memo(ReelsReferenceFields);
